import { render, staticRenderFns } from "./Requests.vue?vue&type=template&id=3e152da4&scoped=true&"
import script from "./Requests.vue?vue&type=script&lang=js&"
export * from "./Requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e152da4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VChip,VContainer,VDataTable,VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VMenu,VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("/home/forge/demo.ec-direct.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e152da4')) {
      api.createRecord('3e152da4', component.options)
    } else {
      api.reload('3e152da4', component.options)
    }
    module.hot.accept("./Requests.vue?vue&type=template&id=3e152da4&scoped=true&", function () {
      api.rerender('3e152da4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/Requests.vue"
export default component.exports